import React from "react";
import * as constants from '../../constants';
import { DEFAULT_COLOR_ACCENT } from "../../../constants";
import { widgetSettingButtonLocation, widgetSettingColumnsCount, widgetSettingPrimaryButtonFilled } from "../../models";
import CPSettingRadio from "../../../../../UI/Settings/CPSettingRadio";
import CPSettingColor from "../../../../../UI/Settings/CPSettingColor";
import CPSettingRange from "../../../../../UI/Settings/CPSettingRange";
import CPSettingSize from "../../../../../UI/Settings/CPSettingSize";
import WidgetLanguageSetting, { LANGUAGE } from "../../../components/Settings/WidgetLanguageSetting";

const CommonSettings = ({eventSettings, onChange}) => {
    return (
        <>
            <WidgetLanguageSetting
                lang={eventSettings?.[LANGUAGE]}
                onUpdate={(key, value) => onChange({[key]: value})}
            />
            <CPSettingRadio
                name={constants.WIDGET_COLUMNS_COUNT}
                eventValue={eventSettings?.[constants.WIDGET_COLUMNS_COUNT]}
                defaultValue="1"
                label="Количество колонок"
                options={widgetSettingColumnsCount}
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.WIDGET_BACKGROUND_COLOR}
                label="Цвет фона"
                eventColor={eventSettings?.[constants.WIDGET_BACKGROUND_COLOR]}
                defaultColor={"#FFFFFF"}
                onChange={onChange}
            />
            <CPSettingRange
                name={constants.WIDGET_BACKGROUND_OPACITY}
                value={eventSettings?.[constants.WIDGET_BACKGROUND_OPACITY]}
                defaultValue={100}
                label="Прозрачность"
                step={5}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_BACKGROUND_BLUR}
                label="Размытие"
                eventValue={eventSettings?.[constants.WIDGET_BACKGROUND_BLUR]}
                defaultValue={'0px'}
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.WIDGET_ACCENT_COLOR}
                label="Акцентный цвет"
                eventColor={eventSettings?.[constants.WIDGET_ACCENT_COLOR]}
                defaultColor={DEFAULT_COLOR_ACCENT}
                hint="Галочки в чек-боксах, цвет ссылок, прелоадер"
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_BUTTONS_BORDER_RADIUS}
                eventValue={eventSettings?.[constants.WIDGET_BUTTONS_BORDER_RADIUS]}
                label="Скругление кнопок"
                defaultValue={'8px'}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_BUTTONS_HEIGHT}
                eventValue={eventSettings?.[constants.WIDGET_BUTTONS_HEIGHT]}
                label="Высота кнопок"
                defaultValue={'44px'}
                onChange={onChange}
            />
            <p>Кнопка Primary:</p>
            <CPSettingColor
                name={constants.WIDGET_PRIMARY_BUTTON_TEXT_COLOR}
                label="Цвет текста"
                eventColor={eventSettings?.[constants.WIDGET_PRIMARY_BUTTON_TEXT_COLOR]}
                defaultColor={"#FFFFFF"}
                onChange={onChange}
            />
            <CPSettingRadio
                name={constants.WIDGET_PRIMARY_BUTTON_FILLED}
                eventValue={eventSettings?.[constants.WIDGET_PRIMARY_BUTTON_FILLED]}
                defaultValue="filled"
                label="Заполнение"
                options={widgetSettingPrimaryButtonFilled}
                hint="Цвет контура будет таким же, как и цвет текста"
                onChange={onChange}
            />
            {eventSettings?.[constants.WIDGET_PRIMARY_BUTTON_FILLED] === 'bordered' && (
                <CPSettingSize
                    name={constants.WIDGET_PRIMARY_BUTTON_BORDER}
                    eventValue={eventSettings?.[constants.WIDGET_PRIMARY_BUTTON_BORDER]}
                    label="Ширина рамки"
                    defaultValue={'2px'}
                    onChange={onChange}
                />
            )}
            <CPSettingRadio
                name={constants.WIDGET_PRIMARY_BUTTON_LOCATION}
                eventValue={eventSettings?.[constants.WIDGET_PRIMARY_BUTTON_LOCATION]}
                defaultValue="flex-start"
                label="Расположение кнопки"
                options={widgetSettingButtonLocation}
                onChange={onChange}
            />
            <p>Кнопка Secondary:</p>
            <CPSettingColor
                name={constants.WIDGET_SECONDARY_BUTTON_TEXT_COLOR}
                label="Цвет текста"
                eventColor={eventSettings?.[constants.WIDGET_SECONDARY_BUTTON_TEXT_COLOR]}
                defaultColor={'#3A3A3A'}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_SECONDARY_BUTTON_BORDER}
                eventValue={eventSettings?.[constants.WIDGET_SECONDARY_BUTTON_BORDER]}
                label="Ширина рамки"
                defaultValue={'2px'}
                onChange={onChange}
            />
        </>
    );
};

export default CommonSettings;
